import { useState, useEffect } from 'react';

import * as gatewayService from '@frolight/services/api/gatewayService';

const useUnregisteredGatewaysForUserData = (gatewayRegistrationRequests) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  useEffect(() => {
    let mounted = true;
    
    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const getUnregisteredGatewaysResponse = await gatewayService.getUnregisteredGateways(
          abortController,
          { gatewayIds: gatewayRegistrationRequests.map(request => request.gatewayId) }
        );
        if (mounted) setData(getUnregisteredGatewaysResponse.data);
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (gatewayRegistrationRequests) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }

  }, [ gatewayRegistrationRequests ]);

  return { loading, error, data };
};

export default useUnregisteredGatewaysForUserData;